import styled from 'styled-components';

import {
  Container as SemanticContainer,
  Dropdown as SemanticDropdown,
} from 'semantic-ui-react';

import {
  Button as ButtonLayoutComponent,
  Text as TextLayoutComponent,
} from '@playbookux/playbook-web-core';
import SearchLayoutComponent from '../../../core/layout-components/search';
import DropdownWithCheckbox from '../../../core/components/folder-dropdown-checkbox';
import UserDropdownCheckbox from '../../../core/components/user-dropdown-checkbox';

const Main = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-top: 78px;
  overflow-anchor: none;
`;

const Typography = styled.p`
  font-size: ${(props) => (props.fontSize ? props.fontSize : '24px')};
  color: ${(props) => (props.color ? props.color : '#172b4d')};
  font-weight: ${(props) => (props.weight ? props.weight : 'normal')};
  &&&&& {
    margin-bottom: ${(props) => (props.marginBottom ? props.marginBottom : '')};
  }
`;

const CreateProject = styled.div`
  align-items: center;
  border-radius: 2px;
  border: 1.5px dashed ${(props) => props.theme.color.primary};
  cursor: pointer;
  display: flex;
  flex-direction: column;
  height: 280px;
  justify-content: center;
  margin: 10px;
  width: 280px;
`;

const PlusSign = styled.p`
  font-size: 54pt;
  color: ${(props) => props.theme.color.primary};
  margin-bottom: 0px;
  font-weight: lighter;
`;

const Container = styled(SemanticContainer)`
  &&& {
    @media only screen and (min-width: 1200px) {
      width: 1190px;
    }
  }
`;

const Button = styled(ButtonLayoutComponent)`
  &.ui.button {
    font-size: 14px;
    margin: 0 10px;
  }

  @media (max-width: 1199px) {
      &.ui.button {
      margin: 0 0 0 0;
    }
  }
`;

const ContainerButtonCreate = styled.div`
  margin-left: auto;
  @media (max-width: 1199px) {
    margin-left: unset;
    margin: 10px 0 0 0;
  }
`;

const ContainerOptions = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  flex-wrap: wrap;
`;

const FilterContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  margin-bottom: 20px;
`;

const Title = styled(TextLayoutComponent.Title)`
`;

const CreateNewProject = styled(TextLayoutComponent.Bold).attrs((props) => ({
  color: props.theme.color.primary,
  fontSize: '18px',
}))`
`;

const Search = styled(SearchLayoutComponent)``;

const ContainerSearch = styled.div`
  margin-right: 20px;
`;

const Dropdown = styled(SemanticDropdown)`
  &&&.ui.selection.dropdown {
    border-color: #DEDEDF;
    border-radius: 4px;
    font-size: 14px;
    height: fit-content;
    min-height: 38px;
    position: absolute;
    z-index: 1;
    width: min-content;
  }
  &.ui.visible.selection.dropdown {
    border-color: #DEDEDF;
    border-radius: 4px;
    font-size: 14px;
    height: 38px;
    .menu {
      border-color: #DEDEDF;
    }
  }
`;

const ContainerDropdownStatus = styled.div`
  margin-right: 20px;
  min-width: 196px;
  @media (max-width: 631px) {
    margin-top: 10px;
  }
`;

const FolderDropdown = styled(DropdownWithCheckbox).attrs({
  height: '38px',
  width: '210px',
})``;

const ContainerFolderDropdown = styled.div`
  margin-right: 20px;

  @media (max-width: 991px) {
    margin-top: 10px;
  }

`;

const UserDropdown = styled(UserDropdownCheckbox).attrs({
  height: '38px',
  width: '210px',
})``;

const ContainerUserDropdown = styled.div`
  margin-right: 20px;

  @media (max-width: 1199px) {
    margin-top: 10px;
  }

`;

export {
  Container,
  CreateNewProject,
  CreateProject,
  Dropdown,
  FolderDropdown,
  ContainerFolderDropdown,
  UserDropdown,
  ContainerUserDropdown,
  FilterContainer,
  Main,
  Button,
  PlusSign,
  Search,
  Title,
  Typography,
  ContainerOptions,
  ContainerDropdownStatus,
  ContainerSearch,
  ContainerButtonCreate,
};
